import React from 'react';

import {
  FilePreviewIcon,
  FilePreviewInfo,
  FilePreviewItem,
  FilePreviewName,
  FilePreviewRemove,
  FilePreviewSize,
  FilePreviewThumbnail,
  FilePreviewContainer as StyledFilePreviewContainer,
} from '../ChatSingle.styles';

const getFileType = (file) => {
  const mimeType = file.type;

  if (mimeType.startsWith('image/')) return 'image';
  if (mimeType.startsWith('video/')) return 'video';
  if (mimeType.startsWith('audio/')) return 'audio';
  return 'file';
};

const getFileIcon = (file) => {
  const mimeType = file.type;
  const extension = file.name.split('.').pop()?.toLowerCase();

  if (mimeType.startsWith('image/')) return '🖼️';
  if (mimeType.startsWith('video/')) return '🎬';
  if (mimeType.startsWith('audio/')) return '🎵';
  if (mimeType.startsWith('application/pdf')) return '📄';
  if (mimeType.includes('word') || extension === 'doc' || extension === 'docx') return '📝';
  if (mimeType.includes('sheet') || extension === 'xls' || extension === 'xlsx') return '📊';
  if (mimeType.includes('zip') || extension === 'zip' || extension === 'rar') return '📦';
  return '📎';
};

const formatFileSize = (bytes) => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + ' ' + sizes[i];
};

const FilePreviewContainer = ({ selectedFile, filePreviewUrl, onRemove }) => {
  if (!selectedFile) return null;

  return (
    <StyledFilePreviewContainer>
      <FilePreviewItem>
        {filePreviewUrl ? (
          <FilePreviewThumbnail src={filePreviewUrl} alt={selectedFile.name} />
        ) : (
          <FilePreviewIcon $fileType={getFileType(selectedFile)}>
            {getFileIcon(selectedFile)}
          </FilePreviewIcon>
        )}
        <FilePreviewInfo>
          <FilePreviewName title={selectedFile.name}>{selectedFile.name}</FilePreviewName>
          <FilePreviewSize>{formatFileSize(selectedFile.size)}</FilePreviewSize>
        </FilePreviewInfo>
        <FilePreviewRemove onClick={onRemove} aria-label="Remove file" title="Remove file" />
      </FilePreviewItem>
    </StyledFilePreviewContainer>
  );
};

export default FilePreviewContainer;
